import { Select, Input } from 'antd';
import { Button } from '../button';
import React from 'react';
import { ImageHolder } from '../image-holder';
import { DeleteOutlined } from '@ant-design/icons';

import style from './style.module.scss';
import { NhlGameReward } from '../../types/nhl-game';

/**
 * Only what the option list renders. Structural rather than the store's
 * `VisiblePromotionRow` so this component keeps its own contract, the way
 * `ReusableCouponPromotion` does for the loyalty club picker.
 */
export type NhlGameRewardPromotion = {
    id: number;
    items: {
        title?: string | null;
        thumbnail?: string | null;
    }[];
};

/**
 * Promotions can be saved before their bilingual content is filled in, so an
 * option row may have no items at all. Fall back to the id so the picker
 * still labels the coupon.
 */
export const promotionOptionLabels = (promo: NhlGameRewardPromotion) => {
    const primary = promo.items[0];
    const secondary = promo.items[1];
    const fallback = `Promotion #${promo.id}`;

    return {
        title: primary?.title || fallback,
        subTitle: secondary?.title || '',
        thumbnail: primary?.thumbnail || undefined,
    };
};

export interface NhlGameRewardsProps {
    privatePromotions: NhlGameRewardPromotion[];
    loading: boolean;
    value: NhlGameReward[];
    setValue: (v: NhlGameReward[]) => void;
}

export const NhlGameRewardsForm = ({
    privatePromotions,
    loading,
    value,
    setValue,
}: NhlGameRewardsProps) => {
    const [rewardsList, setRewardsList] = React.useState<NhlGameReward[]>(
        value ? value : []
    );

    React.useEffect(() => {
        setValue(rewardsList);
        console.log('value', value);
    }, [rewardsList]);

    const addReward = () => {
        const newReward: NhlGameReward = {
            id: null,
            active: true,
            promotionId: privatePromotions[0].id,
            pucksValue: 0,
        };
        setRewardsList([...rewardsList, newReward]);
    };

    const removeReward = (index: number) => {
        const newList = [...rewardsList].filter((_, i) => i !== index);
        setRewardsList(newList);
    };

    const updateReward = (
        index: number,
        key: keyof NhlGameReward,
        value: NhlGameReward[keyof NhlGameReward]
    ) => {
        const newList = [...rewardsList];
        newList[index][key] = value as never;
        setRewardsList(newList);
    };

    return (
        <>
            {rewardsList.map((reward, index) => (
                <div key={index} className={style.container}>
                    <span>Reward {index + 1}</span>
                    <br />
                    <div className={style.input_row}>
                        <Select
                            className={style.section}
                            listHeight={512}
                            showSearch
                            optionLabelProp="label"
                            filterOption={false}
                            loading={loading}
                            value={reward.promotionId}
                            onChange={(value) =>
                                updateReward(index, 'promotionId', value)
                            }
                        >
                            {privatePromotions.map((promo) => {
                                const labels = promotionOptionLabels(promo);

                                return (
                                    <Select.Option
                                        key={promo.id}
                                        value={promo.id}
                                        label={labels.title}
                                    >
                                        <div>
                                            <div>
                                                <span>{labels.title}</span>
                                                <span>{labels.subTitle}</span>
                                            </div>
                                            <ImageHolder
                                                src={labels.thumbnail}
                                                size={40}
                                            />
                                        </div>
                                    </Select.Option>
                                );
                            })}
                        </Select>
                        <div className={style.right_section}>
                            <Input
                                type="number"
                                placeholder="Pucks Value"
                                className={style.pucks}
                                value={
                                    reward.pucksValue !== 0
                                        ? reward.pucksValue
                                        : ''
                                }
                                onChange={(e) =>
                                    updateReward(
                                        index,
                                        'pucksValue',
                                        parseInt(e.target.value)
                                    )
                                }
                            />
                            <Button
                                variant="primary"
                                onClick={() => removeReward(index)}
                                className={style.remove}
                                icon={<DeleteOutlined />}
                            >
                                Delete
                            </Button>
                        </div>
                    </div>
                </div>
            ))}
            <Button
                variant="primary"
                onClick={addReward}
                style={{ marginLeft: '10px' }}
            >
                Add Reward
            </Button>
        </>
    );
};
